export default {
  public: {
    loading: "Memuat...",
    ok: "OK",
    cancel: "Batal",
    back: "Kembali",
    userDefined: "Kustom",
    edit: "Edit",
    clear: "Hapus",
    delete: "Hapus",
    close: "Tutup",
    remove: "Hapus",
    preView: "Pratinjau",
    replace: "Ganti",
    systemMsg: "Informasi",
    generateSuccess: "Presentasi PowerPoint Anda telah berhasil dibuat!",
    templateChoose:
      "Pilih sebuah template untuk menyelesaikan kreasi AI Anda sendiri",
    templateChooseShort: "Pilih template",
    templateChangeTips:
      "Mengganti data template akan mengembalikannya ke konten aslinya. Konten yang dimodifikasi akan hilang. Apakah Anda yakin ingin melanjutkan?",
    sourceInvalid: "Sumber data tidak valid, silakan coba lagi.",
    systemBusy: "Server sedang sibuk, silakan segarkan halaman.",
    templateReplaceSuccess:
      "Penggantian template berhasil. Harap simpan secara manual, karena sistem tidak akan menyimpan secara otomatis.",
    shareLinkTips: "Berhasil menyalin. Mengalihkan halaman web sekarang!",
    noPermissionTips:
      "Maaf, izin berbagi presentasi ini telah ditutup oleh pengarang~ Anda dapat masuk ke aippttv, tunjukkan imajinasi Anda, dan buat presentasi Anda sendiri!",
    copyTips: "Berhasil menyalin!",
    loginTips: "Silakan login terlebih dahulu!",
    bottomTag: "Dibuat dengan {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Font",
      sysFont: "Font Sistem",
      lineFont: "Font Online",
      fontColor: "Warna Teks",
      textColor: "Warna Font",
      fontDelay: "Penyorotan Font",
      addSize: "Tambah Ukuran Font",
      duceSize: "Kurangi Ukuran Font",
      left: "Rata Kiri",
      middle: "Tengah",
      horizontalCenter: "Tengah Horizontal",
      verticalCenter: "Tengah Vertikal",
      right: "Rata Kanan",
      bottom: "Rata Bawah",
      top: "Rata Atas",
      bold: "Tebal",
      em: "Miring",
      underline: "Garis Bawah",
      strikethrough: "Coret",
      richText: "Hapus Format",
      textFormat: "Kuas Format",
      addIndex: "Tambah Indentasi",
      duceIndex: "Kurangi Indentasi",
      no: "Penomoran",
      link: "Hyperlink",
      inputLink: "Masukkan Hyperlink",
      superscript: "Superskrip",
      subscript: "Subskrip",
      code: "Kode Inline",
      blockquote: "Kutipan",
      horizontal: "Horizontal",
      vertical: "Vertikal",
      width: "Lebar",
      height: "Tinggi",
      rotate: "Putar",
      uniformHorizontal: "Distribusi Secara Horizontal",
      uniformVertical: "Distribusi Secara Vertikal",
      combine: "Gabungkan",
      unCombine: "Bongkar",
      bgColor: "Warna Latar Belakang",
      mainColor: "Warna Tema",
      useMainToAll: "Terapkan Tema ke Semua",
      preMain: "Tema Tersedia",
    },
    specialEffects: {
      useAll: "Terapkan ke Semua",
      no: "Tidak Ada",
      fade: "Fade In/Out",
      slideX: "Geser Kiri/Kanan",
      slideY: "Geser Atas/Bawah",
    },
  },
  chart: {
    insertCol: "Sisipkan Kolom",
    insertRow: "Sisipkan Baris",
    delCol: "Hapus Kolom",
    delRow: "Hapus Baris",
    merCell: "Gabungkan sel",
    unMerCell: "Pisahkan sel",
    selectCurrentCol: "Pilih kolom saat ini",
    selectCurrentRow: "Pilih baris saat ini",
    selectAll: "Pilih semua sel",
    toTheLeft: "Ke kiri",
    toTheRight: "Ke kanan",
    toTheTop: "Ke atas",
    toTheBottom: "Ke bawah",
  },  
  desktop: {
    fileExportSuccess:
      "El archivo se ha exportado correctamente. Seleccione una ubicación para guardar el archivo’, translate Indonesian: ‘Berkas berhasil diekspor. Pilih lokasi untuk menyimpan berkas",
    unSupportPreviewPDF: "Pratinjau PDF saat ini tidak didukung",
  },
  extension: {
    nonsupportDownloadPDF:
      "Pratilik PDF tidak tersedia di sini. Jika anda ingin melihat pratilik, silakan pergi ke situs web resmi PC.",
  },

  index: {
    createText: "Membuat Konten PPT",
    createPage: "Membuat Konten untuk Halaman {0}",
    haveProblem: "Saya memiliki masalah",
    systemError: "{0}",
    saveText: "Berhasil disimpan",
    saveMessage: "Apakah Anda yakin untuk menyimpan?",
    cBtn: "Batal",
    sBtn: "OK",
    waitMsg:
      "Harap bersabar dan tunggu selama 30-40 detik. Jika tidak menghasilkan, harap segarkan browser Anda dan coba lagi!",
  },
  errorCode: {
    "401": "Autentikasi gagal, tidak dapat mengakses sumber daya sistem",
    "403": "Operasi saat ini tidak diizinkan",
    "404": "Sumber daya tidak ditemukan",
    default: "Kesalahan sistem tidak dikenal, harap laporkan ke administrator",
    notReDo: "Data sedang diproses, harap jangan mengirim ulang.",
    loginMsg:
      "Sesi tidak valid atau sesi telah kedaluwarsa. Silakan masuk kembali.",
    errMsg: "Sistem sedang sibuk, silakan coba lagi nanti.",
  },
  linkHandler: {
    pptPage: "Halaman Slide",
    change: "Ubah",
    remove: "Hapus",
  },
  editor: {
    ctrlV: "Tempel",
    ctrlA: "Pilih Semua",
    enter: "Halaman Baru",
    f5: "Tayangan Slide",
    delete: "Hapus Halaman",
    ctrlD: "Duplikat Halaman",
    ctrlX: "Potong",
    ctrlC: "Salin",
    shiftF5: "Mulai dari Sekarang",
    positionPanel: {
      horizontalCenter: "Pusat secara horizontal",
      verticalCenter: "Pusat secara vertikal",
      horizontalVerticalCenter: "Pusat secara horizontal dan vertikal",
      left: "Rata kiri",
      right: "Rata kanan",
      top: "Rata atas",
      bottom: "Rata bawah",
      onTop: "Letakkan di atas",
      onBottom: "Letakkan di bawah",
      levelUp: "Pindah satu tingkat ke atas",
      levelDown: "Pindah satu tingkat ke bawah",
      setLink: "Atur Tautan",
      ungroup: "Bongkar grup",
      group: "Grup",
      selectAll: "Pilih Semua",
      lock: "Kunci",
      unlock: "Buka",
      delete: "Hapus",
    },
    canvas: {
      index: {
        ctrlR: "Penggaris",
        ctrlW: "Garis Bantu",
        nl: "Tidak Ada",
        small: "Kecil",
        middle: "Sedang",
        big: "Besar",
        closePan: "Tutup Panel Pilihan",
        openPan: "Buka Panel Pilihan",
        reCurrentPage: "Reset Halaman Saat Ini",
        showPpt: "Tayangan Slide",
        generate:'Mengenerate...'
      },
      linkDialog: {
        url: "Silakan Masukkan Alamat Tautan Web",
        ppt: "Slide",
        preView: "Pratinjau",
        pageUrl: "Tautan Web",
        pptPage: "Halaman Slide",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Batalkan",
        reSet: "Ulangi",
        text: "Masukkan Teks",
        horizontal: "Kotak Teks Horizontal",
        vertical: "Kotak Teks Vertikal",
        image: "Masukkan Gambar",
        shape: "Masukkan Bentuk",
        line: "Masukkan Garis",
        chart: "Masukkan Grafik",
        table: "Masukkan Tabel",
        gs: "Masukkan Formula",
        voice: "Masukkan Audio/Video",
        screen: "Fit ke Layar",
        workspase: "Ruang Kerja",
        save: "Simpan",
        logo: "Masukkan Logo",
        close: "Tutup PPT",
        share: "Bagikan",
        download: "Unduh",
        templateReplacement: "Penggantian Templat",
      },
      mediaInput: {
        videoUrl: "Masukkan URL Video, contoh, https://xxx.mp4",
        voiceUrl: "Masukkan URL Audio, contoh, https://xxx.mp3",
        video: "Video",
        voice: "Audio",
        videoError: "Harap Masukkan URL Video yang Benar Terlebih Dahulu",
        voiceError: "Harap Masukkan URL Audio yang Benar Terlebih Dahulu",
      },
      tableGenerator: {
        table: "Tabel",
        row: "Baris",
        column: "Kolom",
        rcError: "Baris/Kolom harus antara 0 dan 20!",
      },
      logo: {
        text1: "Unggah Logo Perusahaan",
        text2: "Masukkan nama perusahaan",
        companyNamePlaceholder: "masukkan nama perusahaan Anda",
        single: "Aplikasi halaman tunggal",
        all: "Aplikasi semua halaman",
        position: "posisi",
      },
    },
    editorHeader: {
      index: {
        file: "Berkas",
        importPptistFile: "Impor Berkas pptist",
        importPptxFile: "Impor Berkas pptx",
        exportPptxFile: "Ekspor Berkas",
        undo: "Batalkan",
        redo: "Ulangi",
        createSlide: "Tambah Halaman",
        deleteSlide: "Hapus Halaman",
        closeGridLines: "Tutup Garis Kotak",
        openGridLines: "Buka Garis Kotak",
        closeRuler: "Tutup Penggaris",
        openRuler: "Buka Penggaris",
        resetSlides: "Atur Ulang Halaman",
        closeSelectPanel: "Tutup Panel Pilihan",
        openSelectPanel: "Buka Panel Pilihan",
        f5: "Presentasi",
        enterScreeningFromStart: "Mulai dari Awal",
        enterScreening: "Mulai dari Halaman Saat Ini",
        help: "Bantuan",
        hotkey: "Pintasan",
        pptShow: "Tampilkan Slide",
        export: "Ekspor",
        importing: "Mengimpor...",
        continue: "Lanjutkan",
        pauseGeneration: "Jeda",
        noPricing: "Jadilah anggota dan nikmati hak unduh bersama kami.",
        noPricingToOpt: "Buka semua hak istimewa.",
        getTokens: "Upgrade ke Pro",
        pptSlidesMsg: "Selamat atas pembuatan {0} slide PPT lengkap! ",
        Feedback: "Biar AI menjadi asisten kerjamu.",
        giveAway: "Berikan kupon (berlaku selama 30 menit)",
        getItNow: "Dapatkan sekarang",
        unlockAllPpt: "Buka semua fitur PPT",
        grantPermission: "Berikan izin untuk menggunakan peta pikiran AI",
        grantPermissionToUseGpt: "Berikan izin untuk menggunakan GPT",
        permissionCodeUse:
          "Harap ingat kode diskon dan lanjutkan ke halaman pembayaran untuk penggunaan!",
        pptTi1:
          "Anda telah menyelesaikan semua pekerjaan dan menghasilkan total {0} halaman ppt. ",
        pptTi2:
          "Anda hanya perlu langkah terakhir untuk mendapatkan kreasi AI yang menakjubkan!",
      },
    },
    exportDialog: {
      tips:'Pengunduhan PPT tidak didukung di aplikasi saat ini; Silakan Unduh di PC',
      exportScope: "Jangkauan Ekspor",
      close: "Tutup",
      all: "Semua",
      thisPage: "Halaman Ini",
      auto: "Kustom",
      autoScope: "Rentang Kustom",
      exporting: "Mengekspor...",
      exportImg: "Ekspor Gambar",
      expPdf: "Cetak / Ekspor PDF",
      expPptx: "Ekspor PPTX",
      downloadSuccess:
        "Konversi file berhasil. Silakan pilih jalur penyimpanan",
      exportImage: {
        exportType: "Format Ekspor",
        imageQuality: "Kualitas Gambar",
        ignoreFont: "Abaikan Fon Online",
        ignoreLineFont:
          "Secara default, font online akan diabaikan selama ekspor. Jika Anda telah menggunakan font online dalam presentasi dan ingin mempertahankan gaya mereka setelah diekspor, Anda dapat memilih untuk menonaktifkan opsi 'Abaikan Font Online', tetapi harap dicatat bahwa ini dapat meningkatkan waktu ekspor.",
      },
      exportPdf: {
        all: "Semua Slide",
        thisPage: "Slide Saat Ini",
        pageNum: "Halaman per Lembar",
        white: "Margin",
        notice:
          "Catatan: Jika pratinjau cetak tidak sesuai dengan gaya sebenarnya, harap periksa opsi 'Grafik Latar Belakang' dalam jendela cetak yang muncul.",
      },
      exportPPTX: {
        title: "Mengesampingkan Master Default",
        notice:
          "Catatan: Setelah diunduh, harap buka dengan Microsoft Office, karena yang lain mungkin tidak kompatibel.",
      },
    },
    remark: {
      remark: "Klik untuk Masukkan Catatan Pembicara",
    },
    thumbnails: {
      add: "Tambah Slide",
      slide: "Slide",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "Warna Ulang (Masker)",
          maskColor: "Warna Masker",
          opacity: "Opasitas",
        },
        elementFilter: {
          enableFilter: "Aktifkan Filter",
          blur: "Kabur",
          brightness: "Kecerahan",
          contrast: "Kontras",
          grayscale: "Skala Abu-abu",
          saturate: "Saturasi",
          hueRotate: "Putar Hue",
          opacity: "Opasitas",
        },
        elementFlip: {
          horizontal: "Putar secara Horisontal",
          vertical: "Putar secara Vertikal",
        },
        elementOpacity: {
          opacity: "Opasitas",
        },
        elementOutline: {
          border: "Aktifkan Batas",
          borderStyle: "Gaya Batas",
          solid: "Batas Solid",
          dashes: "Batas Bertitik-titik",
          borderColor: "Warna Batas",
          borderWeight: "Tebal Batas",
        },
        elementShadow: {
          enable: "Aktifkan Bayangan",
          horizontal: "Bayangan Horizontal",
          vertical: "Bayangan Vertikal",
          fuzzyDistance: "Jarak Kabur",
          color: "Warna Bayangan",
        },
      },
      panel: {
        background: "Isi Latar Belakang",
        solid: "Isi Warna Solid",
        image: "Isi Gambar",
        gradient: "Isi Gradien",
        contain: "Muat",
        repeat: "Gulir",
        cover: "Muat untuk Mengisi",
        linear: "Gradien Linier",
        radial: "Gradien Radial",
        startColor: "Warna Awal",
        endColor: "Warna Akhir",
        rotate: "Sudut Gradien",
        useBackgroundToAll: "Terapkan Latar Belakang ke Semua",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Kategori",
            colType: "Seri",
          },
          index: {
            edit: "Edit Data Grafik",
            area: "Gaya Grafik Area",
            line: "Gaya Grafik Pencar",
            lineSmooth: "Gunakan Garis Halus",
            horizontalBars: "Gaya Grafik Batang",
            stackBars: "Gaya Tumpuk",
            donut: "Gaya Grafik Donat",
            img: "Legenda",
            hidden: "Sembunyikan",
            showTop: "Tampilkan di Atas",
            showBottom: "Tampilkan di Bawah",
            tabColor: "Warna Kisi",
            labelColor: "Warna huruf",
            titleSetColor: "Warna Tema:",
            title: "Tema yang Direkomendasikan",
            titleColor: "Tambahkan Warna Tema",
          },
        },
        audioStylePanel: {
          imgColor: "Warna Ikon",
          autoPlay: "Putar Otomatis",
          loopPlay: "Putar Berulang",
        },
        imageStylePanel: {
          cutImg: "Potong Gambar",
          shape: "Berdasarkan Bentuk",
          type: "Kategori",
          preview: "Pratinjau",
          use: "Gunakan",
          searchByType: "Cari berdasarkan Kategori",
          uploadAndReplace: "Unggah dan Ganti Gambar",
          reSetStyle: "Atur Ulang Gaya",
          setBackground: "Atur sebagai Latar Belakang",
          clip1: "Berdasarkan Rasio Aspek (Kotak)",
          clip2: "Berdasarkan Rasio Aspek (Potret)",
          clip3: "Berdasarkan Rasio Aspek (Lanskap)",
        },
        latexStylePanel: {
          edit: "Edit LaTeX",
          color: "Warna",
          bold: "Tebal",
        },
        lineStylePanel: {
          style: "Gaya Garis",
          solid: "Garis Solid",
          dotted: "Garis Titik-titik",
          color: "Warna Garis",
          weight: "Ketebalan Garis",
          startStyle: "Gaya Awal",
          endStyle: "Gaya Akhir",
          none: "Tidak Ada",
          arrow: "Panah",
          dot: "Titik",
        },
        multiStylePanel: {
          colorPicker: "Isi Warna",
          style: "Gaya Batas",
          solid: "Batas Solid",
          dotted: "Batas Titik-titik",
          color: "Warna Batas",
          weight: "Ketebalan Batas",
        },
        shapeStylePanel: {
          replaceShade: "Klik untuk Mengganti Bentuk",
          fill: "Isi Solid",
          gradient: "Isi Gradien",
          linear: "Gradien Linier",
          radial: "Gradien Radial",
        },
        tableStylePanel: {
          colFull: "Isi Sel",
          row: "Baris",
          col: "Kolom",
          titleRow: "Baris Judul",
          totalRow: "Baris Total",
          firstCol: "Kolom Pertama",
          lastCol: "Kolom Terakhir",
          titleColor: "Warna Tema",
          themeTable: "Tabel Tema",
        },
        textStylePanel: {
          urlError: "Bukan Alamat Tautan Web yang Benar",
          command: "Daftar Berbulet",
          lineHeight: "Jarak Baris",
          times: "Kali",
          paragraphSpace: "Spasi Paragraf",
          wordSpace: "Spasi Kata",
          textIndent: "Indentasi Baris Pertama",
          textFill: "Isi Kotak Teks",
          title: "Judul",
          titleSmall: "Subjudul",
          text: "Teks",
          textSmall: "Teks [Kecil]",
          zs1: "Catatan 1",
          zs2: "Catatan 2",
        },
        videoStylePanel: {
          cover: "Penutup Pratinjau Video",
          recover: "Atur Ulang Penutup",
        },
      },
      elementAnimationPanel: {
        addEffects: "Tambahkan Animasi",
        selectAndAddEffects: "Pilih Elemen di Kanvas dan Tambahkan Animasi",
        time: "Durasi",
        triggerType: "Jenis Pemicu",
        initiative: "Pemicu Inisiatif",
        sameTime: "Secara Bersamaan dengan Sebelumnya",
        after: "Setelah Sebelumnya",
        change: "Ubah Animasi",
        in: "Masuk",
        out: "Keluar",
        attention: "Penekanan",
      },
    },
    elementPositionPanel: {
      layer: "Lapisan",
      align: "Ratakan",
      top: "Bawa ke Depan",
      bottom: "Kirim ke Belakang",
      up: "Bawa ke Depan",
      down: "Kirim ke Belakang",
      noRixedRatio: "Buka Kunci Rasio Aspek",
      fixedRatio: "Kunci Rasio Aspek",
    },
    index: {
      style: "Gaya",
      symbol: "Simbol",
      position: "Posisi",
      animation: "Animasi",
      design: "Desain",
      slideAnimation: "Transisi",
    },
    slideDesignPanel: {
      canvasSize: "Ukuran Kanvas",
      wideScreen1: "Layar Lebar 16:9",
      wideScreen2: "Layar Lebar 16:10",
      standard: "Standar 4:3",
      paper: "Kertas A3 / A4",
      title: "Tema Global",
      mainColor: "Warna Tema",
      useMainToAll: "Terapkan Tema ke Semua",
      preMain: "Tema Predefined",
      text: "Teks Aa",
      use: "Terapkan",
      useToAll: "Terapkan Semua",
    },
  },
  selectPanel: {
    select: "Pilih",
    showAll: "Tampilkan Semua",
    hideAll: "Sembunyikan Semua",
    group: "Kelompok",
  },
  redraw: {
    topLabel: "Gambar Ulang",
    msgTips: "Silakan masukkan konten yang dihasilkan",
    retext: "Gambar Ulang",
    cltext: "Batal",
    btnText: "Buat",
    reConfirm:
      "Membuat ini akan menggantikan halaman saat ini dan tidak akan menyimpan konten historis. Apakah Anda yakin ingin melanjutkan?",
    confirmBtnTxt: "Lanjutkan",
  },
  screen: {
    presenter: {
      normalView: "Tampilan Normal",
      pen: "Pena",
      laserPointer: "Penunjuk Laser",
      timer: "Penghitung Waktu",
      exitFullScreen: "Keluar Layar Penuh",
      fullScreen: "Layar Penuh",
      endPresentation: "Akhiri Presentasi",
      speakerNotes: "Catatan Pembicara",
      speakersView: "Tampilan Pembicara",
      previousPage: "Halaman Sebelumnya",
      nextPage: "Halaman Berikutnya",
      firstPage: "Halaman Pertama",
      lastPage: "Halaman Terakhir",
      brushTool: "Alat Kuas",
      noRemarks: "Tidak ada catatan",
      lastPageTips: "Sudah halaman terakhir",
      firstPageTips: "Sudah halaman pertama",
      autoPlay: "Mulai tayangan otomatis",
    },
    writingBoard: {
      inkThickness: "Ketebalan Tinta",
      eraserSize: "Ukuran Penghapus",
      eraser: "Penghapus",
      clearInk: "Hapus Tinta",
      blackboard: "Papan Tulis",
      closeBrush: "Tutup Kuas",
    },
  },
  mobile: {
    index: {
      notSupport: "Versi mobile sedang dikembangkan dengan cepat.",
      toPc: "Silakan kunjungi situs web di PC.",
      editTips: "Harap sunting di PC.",
    },
  },
  useCreateElement: {
    type: "Tipe {0}",
    class: "Seri {0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "Masukkan Formula LaTeX",
        preViw: "Pratinjau Formula",
        symbol: "Simbol Umum",
        formula: "Rumus Tertentu",
        error: "Formula tidak boleh kosong",
      },
    },
    colorPicker: {
      recentUse: "Penggunaan Terbaru",
    },
  },
  config: {
    latex: {
      gauss: "Formula Gauss",
      fourierSeries: "Seri Fourier",
      taylorExpansion: "Ekspansi Taylor",
      definiteIntegral: "Integral Definite",
      trigonometricIdentity1: "Identitas Trigonometri 1",
      trigonometricIdentity2: "Identitas Trigonometri 2",
      expansion: "Ekspansi Jumlah",
      euler: "Formula Euler",
      differential: "Persamaan Bernoulli",
      totalDifferentialEquation: "Persamaan Diferensial Total",
      homogeneous: "Persamaan Nonhomogen",
      cauchy: "Teorema Nilai Rata-Rata Cauchy",
      lagrange: "Teorema Nilai Rata-Rata Lagrange",
      arcsin: "Formula Turunan",
      trigonometric: "Integrasi Fungsi Trigonometri",
      quadric: "Permukaan Kuadratik",
      dx: "Diferensial Orde Kedua",
      partial: "Turunan Direksional",
      operators: "Matematika",
      group: "Kombinasi",
      verbatim: "Fungsi",
      greek: "Huruf Yunani",
    },
    symbol: {
      letter: "huruf",
      number: "angka",
      math: "matematika",
      arrow: "panah",
      graph: "grafik",
    },
    lines: {
      straight: "Lurus",
      brokenOrCurve: "Patah atau Melengkung",
    },
  },
  hotkey: {
    opt: {
      common: "Umum",
      ctrlX: "Potong",
      ctrlC: "Salin",
      ctrlV: "Tempel",
      ctrlD: "Salin Tempel Cepat",
      ctrlA: "Pilih Semua",
      ctrlZ: "Batalkan",
      ctrlY: "Lakukan Kembali",
      del: "Hapus",
      ctrlMore: "Pilih Multi",
      ctrlP: "Cetak",
      esc: "Tutup Popup",
    },
    slide: {
      show: "Tampilkan Slide",
      edit: "Edit Slide",
      first: "Mulai Tampilkan Slide dari Awal",
      current: "Mulai Tampilkan Slide dari Saat Ini",
      spacePre: "Beralih ke Halaman Sebelumnya",
      spaceNext1: "Beralih ke Halaman Berikutnya",
      spaceNext2: "Beralih ke Halaman Berikutnya",
      out: "Keluar dari Presentasi",
      new: "Slide Baru",
      move: "Pindahkan Kanvas",
      upOrDown: "Zoom Kanvas",
      up: "Perbesar Kanvas",
      down: "Perkecil Kanvas",
      screen: "Atur Kanvas ke Layar Saat Ini",
      noSelectPrePage: "Halaman Sebelumnya (Elemen Tidak Dipilih)",
      noSelectNextPage: "Halaman Berikutnya (Elemen Tidak Dipilih)",
      prePage: "Halaman Sebelumnya",
      nextPage: "Halaman Berikutnya",
    },
    element: {
      opt: "Operasi Elemen",
      move: "Pindahkan",
      lock: "Kunci",
      combo: "Gabung",
      cancelCombo: "Batal Gabung",
      top: "Bawa ke Depan",
      bottom: "Kirim ke Belakang",
      h: "Kunci Rasio Aspek",
      v: "Buat Garis Horizontal / Vertikal",
      change: "Beralih Fokus Elemen",
      com: "Konfirmasi Pemotongan Gambar",
      text: "teks",
      image: "gambar",
      shape: "bentuk",
      line: "garis",
      chart: "grafik",
      table: "tabel",
      video: "video",
      audio: "audio",
      latex: "Rumus",
    },
    table: {
      edit: "Edit Tabel",
      nextCol: "Fokus pada Sel Berikutnya",
      insertTop: "Sisipkan Baris di Atas",
      insertBottom: "Sisipkan Baris di Bawah",
      insertLeft: "Sisipkan Kolom di Kiri",
      insertRight: "Sisipkan Kolom di Kanan",
    },
    chat: {
      edit: "Edit Data Grafik",
      nextLine: "Fokus pada Baris Berikutnya",
    },
    text: {
      edit: "Edit Teks",
      bold: "Tebal",
      italics: "Miring",
      underline: "Garis Bawah",
      delLine: "Coret",
    },
  },
  shape: {
    rectangle: "Persegi Panjang",
    commonUse: "Bentuk Umum",
    arrow: "Panah",
    other: "Bentuk Lainnya",
    line: "Garis",
  },
  animation: {
    in: {
      bounce: "memantul",
      bounceIn: "memantulMasuk",
      bounceInLeft: "memantulMasukKiri",
      bounceInRight: "memantulMasukKanan",
      bounceInUp: "memantulMasukAtas",
      bounceInDown: "memantulMasukBawah",
      fade: "memudar",
      fadeIn: "memudarMasuk",
      fadeInDown: "memudarMasukBawah",
      fadeInDownBig: "memudarMasukBawahBesar",
      fadeInLeft: "memudarMasukKiri",
      fadeInLeftBig: "memudarMasukKiriBesar",
      fadeInRight: "memudarMasukKanan",
      fadeInRightBig: "memudarMasukKananBesar",
      fadeInUp: "memudarMasukAtas",
      fadeInUpBig: "memudarMasukAtasBesar",
      fadeInTopLeft: "memudarMasukKiriAtas",
      fadeInTopRight: "memudarMasukKananAtas",
      fadeInBottomLeft: "memudarMasukKiriBawah",
      fadeInBottomRight: "memudarMasukKananBawah",
      rotate: "memutar",
      rotateIn: "memutarMasuk",
      rotateInDownLeft: "memutarMasukKiriBawah",
      rotateInDownRight: "memutarMasukKananBawah",
      rotateInUpLeft: "memutarMasukKiriAtas",
      rotateInUpRight: "memutarMasukKananAtas",
      zoom: "memperbesar",
      zoomIn: "memperbesarMasuk",
      zoomInDown: "memperbesarMasukBawah",
      zoomInLeft: "memperbesarMasukKiri",
      zoomInRight: "memperbesarMasukKanan",
      zoomInUp: "memperbesarMasukAtas",
      slide: "meluncur",
      slideInDown: "meluncurMasukBawah",
      slideInLeft: "meluncurMasukKiri",
      slideInRight: "meluncurMasukKanan",
      slideInUp: "meluncurMasukAtas",
      flip: "memutar",
      flipInX: "memutarMasukX",
      flipInY: "memutarMasukY",
      back: "kembali",
      backInDown: "kembaliMasukBawah",
      backInLeft: "kembaliMasukKiri",
      backInRight: "kembaliMasukKanan",
      backInUp: "kembaliMasukAtas",
      lightSpeed: "kecepatanCahaya",
      lightSpeedInRight: "kecepatanCahayaMasukKanan",
      lightSpeedInLeft: "kecepatanCahayaMasukKiri",
    },
    out: {
      bounce: "memantul",
      bounceOut: "memantulKeluar",
      bounceOutLeft: "memantulKeluarKiri",
      bounceOutRight: "memantulKeluarKanan",
      bounceOutUp: "memantulKeluarAtas",
      bounceOutDown: "memantulKeluarBawah",
      fade: "memudar",
      fadeOut: "memudarKeluar",
      fadeOutDown: "memudarKeluarBawah",
      fadeOutDownBig: "memudarKeluarBawahBesar",
      fadeOutLeft: "memudarKeluarKiri",
      fadeOutLeftBig: "memudarKeluarKiriBesar",
      fadeOutRight: "memudarKeluarKanan",
      fadeOutRightBig: "memudarKeluarKananBesar",
      fadeOutUp: "memudarKeluarAtas",
      fadeOutUpBig: "memudarKeluarAtasBesar",
      fadeOutTopLeft: "memudarKeluarKiriAtas",
      fadeOutTopRight: "memudarKeluarKananAtas",
      fadeOutBottomLeft: "memudarKeluarKiriBawah",
      fadeOutBottomRight: "memudarKeluarKananBawah",
      rotate: "memutar",
      rotateOut: "memutarKeluar",
      rotateOutDownLeft: "memutarKeluarKiriBawah",
      rotateOutDownRight: "memutarKeluarKananBawah",
      rotateOutUpLeft: "memutarKeluarKiriAtas",
      rotateOutUpRight: "memutarKeluarKananAtas",
      zoom: "memperbesar",
      zoomOut: "memperbesarKeluar",
      zoomOutDown: "memperbesarKeluarBawah",
      zoomOutLeft: "memperbesarKeluarKiri",
      zoomOutRight: "memperbesarKeluarKanan",
      zoomOutUp: "memperbesarKeluarAtas",
      slide: "meluncur",
      slideOutDown: "meluncurKeluarBawah",
      slideOutLeft: "meluncurKeluarKiri",
      slideOutRight: "meluncurKeluarKanan",
      slideOutUp: "meluncurKeluarAtas",
      flip: "memutar",
      flipOutX: "memutarKeluarX",
      flipOutY: "memutarKeluarY",
      back: "kembali",
      backOutDown: "kembaliKeluarBawah",
      backOutLeft: "kembaliKeluarKiri",
      backOutRight: "kembaliKeluarKanan",
      backOutUp: "kembaliKeluarAtas",
      lightSpeed: "kecepatanCahaya",
      lightSpeedOutRight: "kecepatanCahayaKeluarKanan",
      lightSpeedOutLeft: "kecepatanCahayaKeluarKiri",
    },
    attention: {
      shake: "bergoyang",
      shakeX: "bergoyangX",
      shakeY: "bergoyangY",
      headShake: "bergoyangKepala",
      swing: "mengayun",
      wobble: "bergoyang-goyang",
      tada: "tada",
      jello: "jello",
      other: "lainnya",
      bounce: "memantul",
      flash: "kilat",
      pulse: "denyut",
      rubberBand: "karetGelang",
      heartBeat: "detakJantung",
    },
  },
  requestError: {
    tokenExpires: "Autentikasi gagal, tidak dapat mengakses sumber daya sistem",
    permissionDenied: "Operasi saat ini tidak diizinkan",
    notFound: "Sumber daya tidak ditemukan",
    default:
      "Kesalahan sistem tidak dikenal, harap laporkan kepada administrator",
    exceptionReminder: "Pengingat pengecualian",
    pleaseLogin:
      "Sesi tidak valid, atau sesi telah kedaluwarsa, silakan login kembali.",
    networkError: "Kesalahan Jaringan",
    requestTimeOut: "Waktu permintaan antarmuka sistem habis",
    requestFailed: "Permintaan gagal",
  },
  promptsText: {
    theme: [
      "Jelajahi tema yang berbeda dan temukan kesenangan tak terbatas!",
      "Klik ke setiap halaman tema dan mulailah perjalanan magis!",
      "Setiap tema memiliki daya tarik uniknya sendiri, mengapa tidak menjelajahi semuanya?",
      "Selamat datang di dunia tema, pilih minat Anda dan mulailah petualangan Anda!",
      "Slideshow AI pertama Anda akan segera tiba, tunggu sebentar!",
      "Mulailah perjalanan slideshow, keberangkatan tidak lama lagi...",
      "Siap untuk persembahan visual baru? Slideshow akan segera dimulai...",
      "Pegang erat! Tujuan berikutnya, perjalanan slideshow fantastis...",
      "Cepat! Tutup mata Anda dan tunggu slideshow kejutan tiba...",
      "Dunia slideshow akan terbentang di depan Anda, tetaplah terhubung...",
      "Harap bersabar, mimpi slideshow akan segera menjadi kenyataan...",
    ],
    directory: [
      "Temukan segala yang Anda butuhkan di halaman direktori!",
      "Halaman direktori adalah harta navigasi Anda, membuatnya mudah bagi Anda untuk menemukan yang Anda butuhkan!",
      "Halaman direktori menyediakan layanan navigasi komprehensif, memungkinkan Anda untuk dengan cepat menemukan target Anda!",
      "Tidak yakin mau ke mana? Temukan inspirasi dan arah di halaman direktori!",
    ],
    Content: [
      "Menunggu... slide berikutnya akan secerah pelangi!",
      "Wow! Slide berikutnya akan mekar seperti kembang api, membuat Anda terpesona!",
      "Bersabarlah, slide berikutnya akan seindah menunggu pelangi yang indah muncul!",
      "Rasakan keajaiban menunggu! Slide berikutnya akan mencerahkan mata Anda!",
      "Tetap terhubung! Slide berikutnya akan membawa Anda ke pesta visual kejutan!",
      "Cepat! Tarik tirai, siap-siap untuk merangkul cahaya mempesona dari slide berikutnya!",
      "Siap! Slide berikutnya akan membawa badai visual yang segar!",
      "Rasa ingin tahu Anda akan segera terpuaskan! Slide berikutnya akan mengejutkan Anda!",
      "Menunggu... slide berikutnya akan membawa Anda dalam perjalanan visual yang indah!",
      "Tidak sabar? Slide berikutnya akan seru seperti perayaan besar!",
      "Tebak apa slide berikutnya? Jawabannya akan segera terungkap...",
      "Mohon pasang sabuk pengaman Anda, kami akan terbang ke slide berikutnya...",
      "Kebahagiaan datang! Slide berikutnya sedang menuju ke arah Anda...",
      "Tebak warna slide berikutnya? Jawabannya akan segera terungkap...",
      "Wow! Slide berikutnya akan membawa Anda kejutan tak terduga...",
      "Tertarik untuk mencoba? Slide berikutnya akan memuaskan rasa ingin tahu Anda...",
      "Menunggu... slide berikutnya akan membawa Anda kegembiraan dan kejutan...",
      "Menunggu... sama seperti menunggu secangkir kopi lezat, slide berikutnya akan menyenangkan suasana hati Anda!",
      "Tutup mata Anda, hitung sampai tiga, slide berikutnya akan membawa kejutan! 1... 2... 3...",
      "Dalam petualangan! Menunggu slide berikutnya sama menyenangkannya seperti menemukan harta karun!",
      "Apakah Anda siap? Slide berikutnya akan membawa Anda dalam petualangan yang indah!",
    ],
    Comprehensive: [
      "Perlahan-lahan, jelajahi dunia kesenangan tak terbatas!",
      "Dari tema ke direktori, dan kemudian ke halaman konten, setiap langkah adalah perjalanan penemuan!",
      "Ayo mulai perjalanan indah bersama, meninggalkan tanda kita di dunia yang menarik ini!",
      "Di situs web mengejutkan ini, mari kita temukan lebih banyak bersama-sama!",
    ],
    Unpurchased: [
      "Tertarik untuk mencoba? Slide berikutnya akan memulai pesta visual, bergabunglah dengan kami!",
      "Lebih dari sekadar produk, itu adalah gaya hidup! Klik untuk membeli dan biarkan suasana hati Anda terbang!",
      "Di sini, Anda tidak hanya membeli produk, tetapi juga membeli kebahagiaan dalam jumlah besar!",
      "Bergabung sebagai anggota dan mulailah bab baru kehidupan yang penuh sukacita!",
      "Klik untuk membeli dan membuat setiap hari penuh dengan kejutan dan kesenangan!",
      "Membeli lebih dari sekadar tindakan, itu adalah cara untuk menikmati hidup!",
      "Manfaatkan kesempatan, beli produk yang Anda inginkan, dan membuat hidup lebih berwarna!",
      "Membeli adalah petualangan yang indah, mari kita mulai perjalanan ini bersama!",
      "Klik untuk membeli, berikan diri Anda kejutan dan kebahagiaan!",
      "Membeli adalah ekspresi, mari kita memilih dengan hati bersama-sama!",
    ],
  },
};
